(function () {
  var config = {
    companyId: 'RDZkY9',
    listId: 'V6bRkF',
    tag: 'New_user',
    emptyEmailText: '\u041c\u043e\u043b\u044f, \u0432\u044a\u0432\u0435\u0434\u0435\u0442\u0435 \u0432\u0430\u043b\u0438\u0434\u0435\u043d \u0438\u043c\u0435\u0439\u043b.',
    successText: '\u0411\u043b\u0430\u0433\u043e\u0434\u0430\u0440\u0438\u043c! \u0423\u0441\u043f\u0435\u0448\u043d\u043e \u0441\u0435 \u0430\u0431\u043e\u043d\u0438\u0440\u0430\u0445\u0442\u0435 \u0437\u0430 \u0431\u044e\u043b\u0435\u0442\u0438\u043d\u0430.',
    errorText: '\u0412\u044a\u0437\u043d\u0438\u043a\u043d\u0430 \u0433\u0440\u0435\u0448\u043a\u0430. \u041c\u043e\u043b\u044f, \u043e\u043f\u0438\u0442\u0430\u0439\u0442\u0435 \u043e\u0442\u043d\u043e\u0432\u043e.'
  };
  var configElement = document.getElementById('VerychiFooterNewsletterConfig');

  if (configElement) {
    try {
      var parsedConfig = JSON.parse(configElement.textContent || '{}');
      config.companyId = parsedConfig.companyId || config.companyId;
      config.listId = parsedConfig.listId || config.listId;
      config.tag = parsedConfig.tag || config.tag;
      config.emptyEmailText = parsedConfig.emptyEmailText || config.emptyEmailText;
      config.successText = parsedConfig.successText || config.successText;
      config.errorText = parsedConfig.errorText || config.errorText;
    } catch (e) {}
  }

  var KLAVIYO_COMPANY_ID = config.companyId;
  var KLAVIYO_LIST_ID = config.listId;
  var KLAVIYO_TAG = config.tag;

  function setDrawerNewsletterStickyState(enabled) {
    if (!(window.jQuery && jQuery)) return;
    jQuery('body').toggleClass('newsletter-from-drawer-open', !!enabled);
  }

  function openNotifyPopupFromFooter(options) {
    options = options || {};
    var openedFromDrawer = !!options.openedFromDrawer;

    if (window.jQuery && jQuery.magnificPopup && jQuery('#GlobalNewsletterPopup').length) {
      jQuery.magnificPopup.open({
        items: { src: '#GlobalNewsletterPopup', type: 'inline' },
        midClick: true,
        closeOnBgClick: true,
        enableEscapeKey: true,
        showCloseBtn: true,
        closeBtnInside: true,
        mainClass: 'footer-newsletter-mfp',
        callbacks: {
          open: function () {
            setDrawerNewsletterStickyState(openedFromDrawer);
          },
          close: function () {
            setDrawerNewsletterStickyState(false);
          }
        }
      });
      return true;
    }

    return false;
  }

  function closeOpenDrawerBeforePopup() {
    if (!(window.jQuery && jQuery)) return;
    var $body = jQuery('body');
    var $html = jQuery('html');
    var drawerWasOpen = $body.hasClass('js-drawer-open') || $html.hasClass('js-drawer-open');

    try {
      if (window.timber && window.timber.LeftDrawer && window.timber.LeftDrawer.drawerIsOpen) {
        window.timber.LeftDrawer.close();
      }
      if (window.timber && window.timber.RightDrawer && window.timber.RightDrawer.drawerIsOpen) {
        window.timber.RightDrawer.close();
      }
    } catch (e) {}

    var $closeBtn = jQuery('#NavDrawer .js-drawer-close').first();
    if (drawerWasOpen && $closeBtn.length) {
      $closeBtn.trigger('click');
    }

    $body.add($html).removeClass('js-drawer-open js-drawer-open-left js-drawer-open-right');
    jQuery('#PageContainer, .page-container').off('.drawer');
    $body.add($html).off('.drawer');
    jQuery('.js-drawer-open-button-left').off('.drawer');
    jQuery('.drawer').removeClass('is-open js-drawer-open');
    jQuery(document).off('focusin.drawer_focus');
  }

  window.openFooterNewsletterPopup = openNotifyPopupFromFooter;

  function bindFooterNewsletterSubmit() {
    var form = document.getElementById('GlobalNewsletterForm');
    if (!form || form.getAttribute('data-kl-bound') === '1') return;
    form.setAttribute('data-kl-bound', '1');

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var emailInput = document.getElementById('GlobalNewsletterEmail');
      var feedbackEl = document.getElementById('GlobalNewsletterFeedback');
      var submitBtn = document.getElementById('GlobalNewsletterSubmit');
      var email = (emailInput && emailInput.value ? emailInput.value.trim() : '');

      if (!email) {
        if (feedbackEl) {
          feedbackEl.className = 'product-request-modal__feedback is-error';
          feedbackEl.textContent = config.emptyEmailText;
        }
        return;
      }

      if (submitBtn) submitBtn.disabled = true;
      if (feedbackEl) {
        feedbackEl.className = 'product-request-modal__feedback';
        feedbackEl.textContent = '';
      }

      try {
        var _learnq = window._learnq || [];
        _learnq.push(['identify', {
          '$email': email,
          'Tag': KLAVIYO_TAG,
          '$consent': ['email'],
          'Newsletter_Subscribed': true,
          'Source': 'Footer Newsletter Popup'
        }]);
      } catch (e) {}

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY_ID, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          'revision': '2026-01-15'
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Footer Newsletter Popup',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    subscriptions: {
                      email: {
                        marketing: {
                          consent: 'SUBSCRIBED'
                        }
                      }
                    },
                    properties: {
                      'Tag': KLAVIYO_TAG
                    }
                  }
                }
              }
            },
            relationships: {
              list: {
                data: {
                  type: 'list',
                  id: KLAVIYO_LIST_ID
                }
              }
            }
          }
        })
      }).then(function (response) {
        if (!response.ok) {
          return response.text().then(function (txt) {
            throw new Error(txt || ('HTTP ' + response.status));
          });
        }
        if (feedbackEl) {
          feedbackEl.className = 'product-request-modal__feedback is-success';
          feedbackEl.textContent = config.successText;
        }
        if (emailInput) emailInput.value = '';
        setTimeout(function () {
          if (window.jQuery && jQuery.magnificPopup) {
            jQuery.magnificPopup.close();
          }
        }, 900);
      }).catch(function () {
        if (feedbackEl) {
          feedbackEl.className = 'product-request-modal__feedback is-error';
          feedbackEl.textContent = config.errorText;
        }
      }).finally(function () {
        if (submitBtn) submitBtn.disabled = false;
      });
    });
  }

  bindFooterNewsletterSubmit();

  document.addEventListener('click', function (event) {
    var closeBtn = event.target.closest('.js-product-request-close');
    if (!closeBtn) return;
    event.preventDefault();
    if (window.jQuery && jQuery.magnificPopup) {
      jQuery.magnificPopup.close();
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    if (!window.jQuery) return;
    jQuery(document).on('click', '.mfp-close, .mfp-bg', function (event) {
      if (!jQuery('#GlobalNewsletterPopup').length) return;
      event.preventDefault();
      jQuery.magnificPopup.close();
    });
  }, { once: true });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    if (!document.querySelector('#GlobalNewsletterPopup')) return;
    if (window.jQuery && jQuery.magnificPopup) {
      jQuery.magnificPopup.close();
    }
  });

  function onNewsletterTrigger(event) {
    var trigger = event.target.closest('.js-footer-newsletter-trigger');
    if (!trigger) return;

    event.preventDefault();
    event.stopPropagation();

    var isDrawerTrigger = !!trigger.closest('#NavDrawer, .drawer, .drawer__inner');
    var isMobileViewport = window.matchMedia && window.matchMedia('(max-width: 991px)').matches;
    var openedFromDrawer = isDrawerTrigger && isMobileViewport;

    closeOpenDrawerBeforePopup();
    setTimeout(function () {
      openNotifyPopupFromFooter({ openedFromDrawer: openedFromDrawer });
    }, 320);
  }

  document.addEventListener('click', onNewsletterTrigger, true);
  document.addEventListener('touchend', onNewsletterTrigger, true);
})();

